export enum InputErrorState {
  None,
  Required = 1 << 0,
  Pattern = 1 << 1,
}
